import PageWrapper from "../page-wrapper/page-wrapper.components";
import { FileText } from "lucide-react";

const DOCFILES = "https://nhcfilestorage.blob.core.windows.net/docfiles";

const DocumentCard = ({ href, imageSrc, title }) => (
    <a
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        className="block group"
    >
        <div className="bg-white rounded-xl border border-gray-200 overflow-hidden shadow-card hover:shadow-card-hover hover:-translate-y-1 transition-all">
            <div className="aspect-[4/3] overflow-hidden bg-gray-100">
                <img
                    src={imageSrc}
                    alt={title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                />
            </div>
            <div className="p-3">
                <p className="text-sm font-medium text-gray-700 group-hover:text-primary transition-colors line-clamp-2">
                    {title}
                </p>
            </div>
        </div>
    </a>
);

const DocumentSection = ({ title, documents }) => (
    <div className="mb-8 last:mb-0">
        <h5 className="text-lg font-semibold text-gray-900 mb-4">{title}</h5>
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
            {documents.map((doc, index) => (
                <DocumentCard key={index} {...doc} />
            ))}
        </div>
    </div>
);

const EnrollmentFillable = () => {
    const sections = [
        {
            title: "Fillable Enrollments",
            documents: [
                { href: `${DOCFILES}/HealthSpendingAccount.html`, imageSrc: "/thumbnails/HSAEnrollment.png", title: "Health Spending Account" },
                { href: `${DOCFILES}/LifestyleSpendingAccount.html`, imageSrc: "/thumbnails/LSAEnrollment.png", title: "Lifestyle Spending Account" },
                { href: `${DOCFILES}/HSA-LSA-FlexibleLimits.html`, imageSrc: "/thumbnails/HSALSAFlex.png", title: "HSA + LSA Flexible Limits" },
                { href: `${DOCFILES}/HSA-LSA-FixedLimits.html`, imageSrc: "/thumbnails/HSALSAFixed.png", title: "HSA + LSA Fixed Limits" },
                { href: `${DOCFILES}/LSACategoryList.html`, imageSrc: "/thumbnails/LSA Category List.png", title: "LSA Category List" },
                { href: `${DOCFILES}/CoreHealthPlus.html`, imageSrc: "/thumbnails/CoreHealthPlus.png", title: "CoreHealth+" },
                { href: `${DOCFILES}/Employee - Dependent Entry Fillable Form.html`, imageSrc: "/thumbnails/EmployeeForm.png", title: "Employee and Dependent Enrollment Form" },
            ]
        },
        {
            title: "Census",
            documents: [
                { href: "/files/EmployeeDataTable.xlsx", imageSrc: "/thumbnails/EmployeeDataTableExcel.png", title: "Employee Data Table (Excel)" },
                { href: "/files/EmployeeDataTable.numbers", imageSrc: "/thumbnails/EmployeeDataTableNumbers.png", title: "Employee Data Table (Numbers)" },
                { href: "/files/EmployeeDataTable.pdf", imageSrc: "/thumbnails/EmployeeDataTablePDF.png", title: "Employee Data Table (PDF)" },
            ]
        }
    ];

    return (
        <PageWrapper>
            <div className="flex-1 px-6 md:px-12 lg:pl-12 lg:pr-24 py-6 pb-5 overflow-y-auto">
                {/* page header with icon */}
                <div className="flex items-center gap-3 mb-6">
                    <div className="p-2 bg-primary/10 rounded-xl">
                        <FileText className="w-6 h-6 text-primary" />
                    </div>
                    <div>
                        <h1 className="text-2xl md:text-3xl font-bold text-gray-900">
                            Enrollment Forms
                        </h1>
                        <p className="text-sm text-gray-500">
                            Fillable enrollment documents
                        </p>
                    </div>
                </div>

                {/* content */}
                <div className="bg-white rounded-2xl shadow-card p-6">
                    {sections.map((section, index) => (
                        <DocumentSection key={index} {...section} />
                    ))}
                </div>
            </div>
        </PageWrapper>
    );
};

export default EnrollmentFillable;
